<template>
  <div class="c-navColumn3">
    <h2 class="c-navColumn3__title">
      <slot name="title"></slot>
    </h2>
    <nav class="c-navColumn3__nav">
      <ul
        id="js-ota-nav"
        class="c-navColumn3__list"
        :class="{ _fixed: isFixedTop }"
      >
        <slot name="items"></slot>
      </ul>
    </nav>
  </div>
</template>

<script>
import { IntersectionObserverOptions, mobileMatchMedia } from './common';

export default {
  name: 'NavColumn3Wrap',
  data() {
    return {
      isFixedTop: false,
    };
  },
  mounted() {
    this.intersectionObserver();
    mobileMatchMedia.addListener(this.checkMedia);
  },
  methods: {
    fixedTop(entries) {
      if (mobileMatchMedia.matches) {
        entries.forEach((entry) => {
          if (
            entry.isIntersecting ||
            (!entry.isIntersecting &&
              entry.boundingClientRect.top <= 0 &&
              entry.boundingClientRect.bottom <= 0)
          ) {
            this.isFixedTop = true;
          } else if (
            !entry.isIntersecting &&
            entry.boundingClientRect.top >= 0 &&
            entry.boundingClientRect.bottom >= 0
          ) {
            this.isFixedTop = false;
          }
        });
      } else {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            this.isFixedTop = true;
          } else if (entry.isIntersecting && entry.boundingClientRect.top < 0) {
            this.isFixedTop = false;
          }
        });
      }
    },
    intersectionObserver() {
      const observer = new IntersectionObserver(
        this.fixedTop,
        IntersectionObserverOptions.default,
      );
      observer.observe(this.$el.querySelector('.c-navColumn3__nav'));

      const pcObserver = new IntersectionObserver(
        this.fixedTop,
        IntersectionObserverOptions.pcOptions,
      );
      pcObserver.observe(this.$el.querySelector('.c-navColumn3__nav'));

      if (mobileMatchMedia.matches) {
        pcObserver.unobserve(this.$el.querySelector('.c-navColumn3__nav'));
      } else {
        observer.unobserve(this.$el.querySelector('.c-navColumn3__nav'));
      }
    },
    checkMedia() {
      if (mobileMatchMedia.matches) {
        this.intersectionObserver();
      } else {
        this.isFixedTop = false;
      }
    },
  },
};
</script>
